import {
  SET_SELECTED_SCENARIOS
} from './types'

const SELECTED_SCENARIOS_STORAGE_KEY = 'SELECTED_SCENARIOS_STORAGE_KEY'

const initialState = {
  selectedScenarios: null
}

const getters = {
  selectedScenarios: state => state.selectedScenarios
}

const actions = {
  initialize ({ commit }) {
    const selectedScenarios = JSON.parse(localStorage.getItem(SELECTED_SCENARIOS_STORAGE_KEY))

    if (selectedScenarios) {
      commit(SET_SELECTED_SCENARIOS, selectedScenarios)
    }
  }
}

const mutations = {
  [SET_SELECTED_SCENARIOS] (state, selectedScenarios) {
    localStorage.setItem(SELECTED_SCENARIOS_STORAGE_KEY, JSON.stringify(selectedScenarios))
    state.selectedScenarios = selectedScenarios
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/scenarios.js